import React, { useContext } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { LangContext } from "../../context/LangContext";
import { VscFilePdf } from "react-icons/vsc";
import Bread from "../../common/Bread";
import "./downloads.scss";
import Loader from "../../common/Loader";

const Downloads = () => {
  const { state } = useContext(LangContext);
  const np = state.np; // true if Nepali is active

  const breadcrumList = {
    image: "",
    link: "",
    title: np ? "डाउनलोडहरू" : "Downloads",
    l1: np ? "होम" : "Home",
    l2: np ? "डाउनलोडहरू" : "Downloads",
    l3: "",
  };

  const { isLoading, isFetching, error, data } = useQuery({
    queryKey: ["downloadsData"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/downloads`)
        .then((res) => res.data),
  });

  if (isLoading || isFetching) return <Loader />;
  if (error) return "An error has occurred: " + error.message;

  // Select language-specific categories
  const downloadsCategories = np
    ? data?.downloads_category?.np
    : data?.downloads_category?.en;

  return (
    <Bread data={breadcrumList}>
      <div className="downloadsPageMainContainer">
        <Tabs className="downloadsPageTabContainer" defaultIndex={0}>
          <TabList className="downloadsPageTabsButtonContainer">
            {downloadsCategories?.map((category, index) => (
              <Tab key={index} className="downloadsPageTabButton">
                {category.title}
              </Tab>
            ))}
          </TabList>

          {downloadsCategories?.map((category, index) => (
            <TabPanel key={index}>
              <div className="downloadsPageResultContainer">
                {category.downloads?.length > 0 ? (
                  category.downloads.map((download, index) => (
                    <a
                      key={index}
                      href={download.DocPath}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="downloadsPageResultItem"
                    >
                      <p className="downloadsPageResultText">
                        {np
                          ? download.titleNepali || download.title
                          : download.title}
                      </p>
                      <VscFilePdf
                        className="icon"
                        color="#3a3a3a"
                        size="25px"
                      />
                    </a>
                  ))
                ) : (
                  <h2>{np ? "डेटा उपलब्ध छैन" : "No data"}</h2>
                )}
              </div>
            </TabPanel>
          ))}
        </Tabs>
      </div>
    </Bread>
  );
};

export default Downloads;
